export default "__VITE_ASSET__b98fdd6c__"